import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { FormikProps } from "formik";
import CustomSelect from "../../../../../../../../../components/CustomSelect";
import PsychoeducationTherapyForm from "./PsychoeducationTherapyForm";
import CustomTextArea from "../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../components/Text";
import CustomTitle from "../../../../../../../../../components/app/CustomTitle";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";
import CptCodesField from "../components/form-components/CptCodesField";
import IcdCodesField from "../components/form-components/IcdCodesField";

interface TreatMentPlanNoteProps {
  formik: FormikProps<Form2Payload>;
}

const TreatMentPlanNote = ({ formik }: TreatMentPlanNoteProps) => {
  return (
    <Flex
      gap={2}
      flexDirection="column"
      p={1.5}
      sx={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTitle>Diagnosis</CustomTitle>
          <Flex flexDirection="row" gap={2} flexWrap="wrap" mt={1}>
            <IcdCodesField formik={formik} label="Add Diagnosis" />
            <CptCodesField formik={formik} />
          </Flex>
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTextArea
            label="Presenting Problem"
            rows={3}
            variant="outlined"
            name="problems"
            placeholder="Enter Presenting Problem"
            onBlur={formik.handleBlur}
            value={formik.values?.problems}
            onChange={formik.handleChange}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTextArea
            label="Treatment Goals"
            rows={3}
            variant="outlined"
            name="treatmentGoal"
            placeholder="Enter Treatment Goals"
            onBlur={formik.handleBlur}
            value={formik.values?.treatmentGoal}
            onChange={formik.handleChange}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomSelect
            label="Treatment Goals Estimated Completion"
            name="estimateCompletionOfTreatmentGoal"
            placeholder="Select Estimated Completion"
            options={ESTIMATED_COMPLETION_OPTIONS}
            value={formik.values?.estimateCompletionOfTreatmentGoal}
            onChange={(opt) => {
              formik.setFieldValue("estimateCompletionOfTreatmentGoal", opt);
            }}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTextArea
            label="Objective"
            rows={3}
            variant="outlined"
            name="objectiveFreeNote"
            placeholder="Enter Objective"
            onBlur={formik.handleBlur}
            value={formik.values?.objectiveFreeNote}
            onChange={formik.handleChange}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTextArea
            label="Treatment Strategy/Intervention"
            rows={3}
            variant="outlined"
            name="treatmentStrategy"
            placeholder="Enter Treatment Strategy/Intervention"
            onBlur={formik.handleBlur}
            value={formik.values?.treatmentStrategy}
            onChange={formik.handleChange}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomSelect
            label="Treatment Strategy/Intervention Estimated Completion"
            name="estimateCompletionOfTreatmentStrategy"
            placeholder="Select Estimated Completion"
            options={ESTIMATED_COMPLETION_OPTIONS}
            value={formik.values?.estimateCompletionOfTreatmentStrategy}
            onChange={(opt) => {
              formik.setFieldValue(
                "estimateCompletionOfTreatmentStrategy",
                opt
              );
            }}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <CustomTextArea
            label="Prescribed Frequency for Treatment"
            rows={3}
            variant="outlined"
            name="frequencyOfTreatment"
            placeholder="Enter Prescribed Frequency for Treatment"
            onBlur={formik.handleBlur}
            value={formik.values?.frequencyOfTreatment}
            onChange={formik.handleChange}
          />
        </Grid>
        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                name="psychoeducationSessionRequired"
                checked={!!formik.values?.psychoeducationSessionRequired}
                onChange={(e) =>
                  formik.setFieldValue(
                    "psychoeducationSessionRequired",
                    e.target.checked
                  )
                }
              />
            }
            label={
              <Text variant="body1" fontWeight={500}>
                Psychoeducation Session Required?
              </Text>
            }
          />
        </Grid>
        {formik.values?.psychoeducationSessionRequired && (
          <Grid size={12}>
            <PsychoeducationTherapyForm formik={formik} />
          </Grid>
        )}
      </Grid>

      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              name="agreedToTreatmentPlan"
              checked={formik.values?.agreedToTreatmentPlan}
              onChange={(e) => {
                formik.setFieldValue("agreedToTreatmentPlan", e.target.checked);
              }}
            />
          }
          label={
            <Text>
              I Declare That These Services Are Medically Necessary And
              Appropriate To The Recipient's Diagnosis And Needs.
            </Text>
          }
        />
      </Grid>
    </Flex>
  );
};

export default TreatMentPlanNote;

const ESTIMATED_COMPLETION_OPTIONS = [
  { value: "1 week", label: "1 week" },
  { value: "2 week", label: "2 week" },
  { value: "3 week", label: "3 week" },
  { value: "1 month", label: "1 month" },
];
